import { Routes } from '@angular/router';
import { ROUTES } from './shared/routing/route.config';

export const routes: Routes = [
	...ROUTES['dashboard'],
	...ROUTES['database'],
	...ROUTES['desk'],
	...ROUTES['admin'],
	...ROUTES['wiki'],
	{
		path: '**',
		redirectTo: 'error',
	},
];
